import { GetDeliveryTypes, GetDeliveryTypesToken } from "$src/application/projects/sub/deliveries/queries/GetDeliveryTypes";
import { DeliveryType } from "$src/domain/projects/deliveries/DeliveryType";
import { useQuery } from "@sveltestack/svelte-query";
import { container } from "tsyringe";

interface FetchDeliveryTypesParams {
    queryKey: ['deliveryTypes', number];
}

export async function fetchDeliveryTypes( { queryKey } : FetchDeliveryTypesParams): Promise<DeliveryType[]> {
    const [_, groupStoreId] = queryKey;
    const query = container.resolve<GetDeliveryTypes>(GetDeliveryTypesToken);
    return query.execute(groupStoreId);
}

export function useDeliveryTypes(groupStoreId: number) {
    return useQuery<DeliveryType[], Error, DeliveryType[], ['deliveryTypes', number]>(
        ['deliveryTypes', groupStoreId],
        fetchDeliveryTypes,
        {
            staleTime: Infinity,
            cacheTime: 1800000,
        }
    );
}